/* eslint-disable class-methods-use-this */
import Cookies from 'js-cookie';

export class CookieStorage {
  domain: string;

  constructor(domain?: string) {
    this.domain = domain || 'quality24.com.br';
  }

  // set item with the key
  setItem(key: string, value: string): string {
    Cookies.set(key, value, {
      domain: process.env.NODE_ENV === 'production' ? this.domain : undefined,
      sameSite: 'strict',
      secure: process.env.NODE_ENV === 'production',
      expires: 35,
    });
    return value;
  }

  // get item with the key
  getItem(key: string): string {
    return Cookies.get(key) || '';
  }

  // remove item with the key
  removeItem(key: string): void {
    Cookies.remove(key, {
      domain: process.env.NODE_ENV === 'production' ? this.domain : undefined,
    });
  }

  // clear out the storage
  clear(): void {
    const cookies = Cookies.get();
    Object.keys(cookies).forEach((k) => this.removeItem(k));
  }

  // If the storage operations are async(i.e AsyncStorage)
  // Then you need to sync those items into the memory in this method
  // static sync(): Promise<void> {
  //   if (!CookieStorage.syncPromise) {
  //     CookieStorage.syncPromise = new Promise((_res, _rej) => {});
  //   }
  //   return CookieStorage.syncPromise;
  // }
}

export const cookieStorage = new CookieStorage();
